import React from 'react'

import { Link, Tag } from '@factorialco/deprecated-design-system'
import { TransactionCardPaymentFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { getStatusLabel } from 'modules/expenses/lib/expensables/statusLabel'
import tagColor from 'modules/expenses/lib/tagColors'

import { CustomDetails } from '../CustomDetails'
import { CustomPairTransactionDetails } from '../CustomPairTransactionDetails'
import { DefaultPairTransactionDetails } from '../DefaultPairTransactionDetails'
import { Files } from './_Files'

export const ExpenseDetails = (cardPayment: TransactionCardPaymentFragment) => {
  const { navigation } = useNavigation()

  if (!cardPayment || !cardPayment.expense) return null

  const expense = cardPayment.expense
  const expensable = cardPayment?.expense?.expensable
  const expensableUrl = navigation.expenses.list.expenses.expenseId.fullPath({
    expense_id: expensable?.id ?? '',
  })

  return (
    <CustomDetails title={i18n.t('expenses_v2.transactions.detail.sections.expense_information')}>
      <DefaultPairTransactionDetails
        desc1={i18n.t('expenses_v2.transactions.detail.fields.merchant')}
        val1={expense.merchantName}
        desc2={i18n.t('expenses_v2.transactions.detail.fields.category')}
        val2={expense.category?.name}
      />
      <CustomPairTransactionDetails
        desc1={i18n.t('expenses_v2.transactions.detail.fields.status')}
        val1={
          <Tag showCircle type={tagColor(expense.status)} inline>
            {getStatusLabel(expense.status)}
          </Tag>
        }
        desc2={i18n.t('expenses_v2.transactions.detail.fields.report_date')}
        val2={
          <Tag type={tagColor(expense.reviewRequestAt)} inline>
            {dateBackendDateTimeToUI(expense.reviewRequestAt || expense.effectiveOn)}
          </Tag>
        }
      />
      <Files expense={expense} />
      <Link.Router to={expensableUrl}>
        {i18n.t('expenses_v2.transactions.detail.actions.view_expense_details')}
      </Link.Router>
    </CustomDetails>
  )
}
